import { useTranslation } from "react-i18next";

export default function NotFoundPage() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center h-screen">
            <div className="text-center select-none">
                <p className="text-4xl font-bold mb-4">
                    {t("pages.not-found.title")}
                </p>
            </div>
        </div>
    );
}
